package amazon.lastmile.inject

import app.nestbridge.feature.profile.ui.ProfileUiFactory
import com.slack.circuit.runtime.ui.Ui
import me.tatarka.inject.annotations.IntoSet
import me.tatarka.inject.annotations.Provides
import software.amazon.lastmile.kotlin.inject.anvil.`internal`.Origin

@Origin(value = ProfileUiFactory::class)
public interface AppNestbridgeFeatureProfileUiProfileUiFactory {
  @Provides
  @IntoSet
  public fun provideProfileUiFactoryFactoryMultibinding(profileUiFactory: ProfileUiFactory): Ui.Factory = profileUiFactory
}
